/**
 * View in charge of the header and notifications.
 *
 * 1. Notifications View
 * 2. Some Kind of account error thing
 * 3. Search Magic
 * 4. Mobile Menu Slider
 *
 * @TODO Make this a react component
 */

import $ from 'jquery'
import { setupHeaderMessagingView } from './loadError-headerMessaging'

// TODO: are these things needed???
// import 'bootstrap-dropdown'
// import 'bootstrap-modal'
// import '../widgets/accessibleModal'

/*
 * Initialize the header for the application by adding in analytics
 * functions and creating an instance of the Notification View.
 */
export function setupHeader() {
  setupEvents()
  setupErrors()
}

// initialize header warning when there is a service error
// TODO: verify that this is used by anyone...
function setupErrors() {
  // TODO: move this to serverProps
  const globalView = document.querySelector('.js_globalNavView')
  const loadError =
    globalView && globalView.getAttribute('data-show-warning') === 'true'
  if (loadError) {
    setupHeaderMessagingView()
  }
}

function setupEvents() {
  $(document.body).on('click', '.headerActions a', () => closeModals())
  $(document.body).on('click', '.js_toggleMobileMenu', e =>
    slideToRevealMenu(e)
  ) // New header method
  $(document.body).on('click', '.toggleMenu', e => toggleMenu(e))
  $(document.body).on('click', '.globalNav a', () => globalNavItemClicked())
}

/**
 * Close any open modals when clicking on header links
 * TODO: make sure this works with react overpanels
 */
function closeModals() {
  $('.openModal').modal('hide')
}

/**
 *    Navigation Menu Link Clicked.
 */
function globalNavItemClicked() {
  // Mobile devices appear to have two active navigation items when clicking a globalNav link.
  $('.globalNav .active').removeClass('active')
}

/**
 * Toggle the left nav open on mobile devices
 * Don't need to detect device here since the
 * toggle button is displayed using media queries
 */
function slideToRevealMenu(event) {
  event.preventDefault()
  $('body').toggleClass('vx_hasOpenNav')
}

function toggleMenu(event) {
  event.preventDefault()
  $('body').toggleClass('overlay-open')
}
